import { useRef } from 'react';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';
import { ArrowDown, ArrowUpRight } from 'lucide-react';

export const StartHero = ({ copy }) => {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start start', 'end start'] });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '8%']);
  const scale = useTransform(scrollYProgress, [0, 1], [1.025, 1.08]);
  return (
    <section ref={ref} className="start-hero" aria-labelledby="start-hero-heading" data-testid="start-hero">
      <motion.div className="start-hero-media" style={reduced ? undefined : { y, scale }}>
        <img src="/images/optimized/DionHairClinic_Eingang.webp" alt={copy.hero.alt} fetchPriority="high" width="1200" height="800" data-testid="start-hero-image" />
      </motion.div>
      <div className="start-hero-scrim" />
      <div className="start-container start-hero-inner">
        <div className="start-hero-topline start-mono" data-testid="start-hero-location"><span>{copy.hero.location}</span><span>{copy.hero.discipline}</span></div>
        <div className="start-hero-copy start-enter">
          <p className="start-hero-brand" data-testid="start-hero-brand">Dion Hair Clinic</p>
          <h1 id="start-hero-heading" data-testid="start-hero-heading">{copy.hero.title[0]}<br /><span>{copy.hero.title[1]}</span></h1>
          <p className="start-hero-description" data-testid="start-hero-description">{copy.hero.text}</p>
          <div className="start-actions">
            <a href="#behandlungen" className="start-button start-button-white" data-testid="start-hero-choose">{copy.hero.choose}<ArrowDown size={17} aria-hidden="true" /></a>
            <a href="/#kontakt" className="start-text-link" data-testid="start-hero-consultation">{copy.hero.consultation}<ArrowUpRight size={17} aria-hidden="true" /></a>
          </div>
        </div>
        <div className="start-hero-bottom start-mono" data-testid="start-hero-footer">
          <span>{copy.hero.fields}</span><span className="start-hero-footnote">{copy.hero.footnote}</span>
          <a href="#behandlungen" aria-label={copy.hero.choose} data-testid="start-hero-scroll" className="start-scroll-link"><ArrowDown size={18} aria-hidden="true" /></a>
        </div>
      </div>
    </section>
  );
};